import KitFrame from '@omni/kit/components/KitFrame';
import { getSpacing } from '@omni/kit/theming/SpacingType';
import { dispatchAction } from '@omni/kit/utilities/NativeHelpers';
import React, { ReactElement } from 'react';
import { View, ViewStyle } from 'react-native';

import BlockPageNested from '../BlockPageNested';
import { IBlockProps } from './types';

export interface FrameBlockProps extends IBlockProps {
  title?: string;
  action?: any;
  enableChevron?: boolean;
  blocks?: [];

  /** ViewStyle: https://reactnative.dev/docs/view-style-props */
  containerStyle?: ViewStyle;
}

const FrameBlock = ({
  title,
  action,
  blocks,
  enableChevron,
  topSpacing,
  bottomSpacing,
  containerStyle = {},
  insetStyle,
}: FrameBlockProps): ReactElement => {
  const _onPress = () => {
    dispatchAction(action);
  };

  const viewStyle = {
    marginTop: getSpacing(topSpacing),
    marginBottom: getSpacing(bottomSpacing),
    ...containerStyle,
  };

  return (
    <View style={insetStyle}>
      <KitFrame
        title={title}
        enableChevron={enableChevron}
        onPress={action ? _onPress : undefined}
        containerStyle={viewStyle}
      >
        <BlockPageNested data={{ blocks: blocks }} />
      </KitFrame>
    </View>
  );
};

export default FrameBlock;
